const QUERY_PRESERVE_PARAMS = [
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_medium",
  "utm_source",
  "category",
  "fvid",
  "gclid",
  "utm_adgroup",
  "utm_network",
  "utm_matchtype",
  "utm_device",
  "utm_placement",
  "utm_adposition",
  "utm_location",
  "utm_sitelink",
  "utm_audience",
  "utm_promotion",
  "utm_price",
  "source",
  "plan_filter",
  "deny_cc",
  "lpSource",
  "flow",
  "product",
  "old_stack",
  "inspectionJourney",
  "registration_number",
  "lsi_portal_flow"
];

export const QUERY_NOT_REQUIRED_FETCH = [
  "lpSource",
  "inspectionJourney",
  "registration_number"
];

export const getUrlWithUtmParams = ({ url, queryParams }) => {
  const urlParams = new URLSearchParams(window.location.search);

  const apiUrl = new URL(`${process.env.HOST_URL}${url}`);

  Object.keys(queryParams)?.forEach(item => {
    const value = queryParams[item];
    if (value) apiUrl.searchParams.append(item, value);
  });

  QUERY_PRESERVE_PARAMS.forEach(item => {
    if (item === "lpSource") return;
    const value = urlParams.get(item);
    if (value) apiUrl.searchParams.append(item, value);
  });

  return apiUrl?.href;
};

type QueryValue = string | string[] | undefined;

export const UTM_QUERY_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term"
];

export const getUtmQueryParams = (
  query: Record<string, QueryValue> = {}
): Record<string, string> => {
  return UTM_QUERY_PARAMS.reduce<Record<string, string>>((utmParams, item) => {
    const value = query[item];
    const queryValue = Array.isArray(value) ? value[0] : value;

    if (queryValue) {
      utmParams[item] = queryValue;
    }

    return utmParams;
  }, {});
};

export default QUERY_PRESERVE_PARAMS;
